document.addEventListener("alpine:init", () => {
  Alpine.data("PDPSubscribe", (settingsOverride = null) => ({
    loading: false,
    email: "",
    errMsg: "",
    disclaimerErrMsg: "",
    checked: true,
    isSuccess: false,

    getSubscribeSettings() {
      if (settingsOverride && typeof settingsOverride === "object") {
        return settingsOverride;
      }
      return typeof subscribeSettingJsons !== "undefined" ? subscribeSettingJsons : {};
    },

    async submitResult() {
      if (!this.checked) {
        this.disclaimerErrMsg = "Please tick agreement boxes to proceed.";
        return;
      }
      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.errMsg = "Email error";
        return;
      }
      // If no error, remove error message
      this.errMsg = "";

      const settings = this.getSubscribeSettings();
      const fieldsArray = createFieldsArray(settings);
      // getContactListId function in subscription-form-common.js
      const contactListId = getContactListId(settings);

      // Extract theme global variables from theme.liquid
      const { apiUrl, acceptedLanguage, apiKey, xAppid } =
        theme.emailSubscription;

      const subscribeInfoCookie = window.getCookieForEmarsys("subscribe_info");
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
          console.log("eventTracking", eventTracking);
        } catch (error) {
          console.log("eventTracking error", subscribeInfoCookie);
          console.warn("Failed to parse subscribe_info cookie:", error);
        }
      }

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };
      this.loading = true;
      try {
        const response = await fetch(
          // Header global settings are defined in star-email-subscription-form.liquid
          // Except traceId is defined in subscription-form-common.js
          apiUrl,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              apiKey: apiKey,
              traceId: traceId,
              "X-appid": xAppid,
              "Accepted-Language": acceptedLanguage,
            },
            body: JSON.stringify(apiBody),
          }
        );

        const data = await response.json();

        if (data.message === "Success") {
          this.isSuccess = true;
          // Fetch may be overwritten after subscription-form-common wraps it;
          // emit subscribe_success explicitly (same pattern as ef-section-pdf-vote).
          if (typeof window.pushSubscribeUaEvent === "function") {
            window.__ecoflowSubscribeSuccessHandled = true;
            const lastContext = window.__ecoflowSubscribeLastTrackingContext || {};
            window.pushSubscribeUaEvent("subscribe_success", {
              ...lastContext,
              status: "success",
              moduleName: lastContext.moduleName || "user-rights-subscribe",
              buttonName: lastContext.buttonName || "Subscribe",
            });
            setTimeout(function () {
              window.__ecoflowSubscribeSuccessHandled = false;
            }, 0);
          }
        }
      } catch (error) {
        this.errMsg =
          "Oops... Something went wrong, please refresh and try again.";
      } finally {
        this.loading = false;
      }
    },
  }));
});
